module.exports = __webpack_public_path__ + "static/media/check.401428af.svg";